<template>
  <div class="offers">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <OffersTable :isReadOnly="isReadOnly" @create-offer="onCreateOffer" @edit-offer="onEditOffer" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import OffersTable from '@/components/Offers/OffersTable';
import { mapGetters } from 'vuex';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { OFFERS_ACCESS_NODE } from '@/navigation/accessNodes';

export default {
  name: 'Offers',
  components: {
    Breadcrumbs,
    OffersTable,
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    /** Viewer on the view offers: lists, cannot create. */
    isReadOnly() {
      return !coversAccessLevel(this.getAccessLevel(OFFERS_ACCESS_NODE), 'editor');
    },
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('offers') }];
    },
  },
  methods: {
    onCreateOffer() {
      this.$router.push({ name: 'OfferCreatePage' });
    },
    onEditOffer(offer) {
      this.$router.push({
        name: 'OfferEditPage',
        params: { offerNumber: offer.number },
      });
    },
  },
};
</script>
